import { render, staticRenderFns } from "./CanadasTerrenos.vue?vue&type=template&id=8da079ae"
import script from "./CanadasTerrenos.vue?vue&type=script&lang=js"
export * from "./CanadasTerrenos.vue?vue&type=script&lang=js"
import style0 from "./CanadasTerrenos.vue?vue&type=style&index=0&id=8da079ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports